export default __webpack_public_path__ + "static/media/locationBackground.f115ae20.PNG";